import React from "react";
import { connect } from "react-redux";

import { Card, CardBody, Row, Col } from "reactstrap";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from 'react-accessible-accordion';

const PreguntasVehiculos = (props) =>
  <Card className="flex-row background-acordeon">
    <CardBody>
      <Row>
        <Col lg={12} md={12} sm={12} xs={12}>
          <Accordion allowZeroExpanded="true">
            {props.datosContenido.preguntas != undefined
              && props.datosContenido.preguntas.map((pregunta, i) =>
                <AccordionItem key={`preguntas${i}`}>
                  <AccordionItemHeading>
                    <AccordionItemButton className="accordion-button-productos">
                      {pregunta.preNombre}
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div style={{ textAlign: "justify", }}>
                      <p />
                      <div dangerouslySetInnerHTML={{ __html: pregunta.preDescripcion }} />
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>
              )
            }
          </Accordion>
        </Col>
      </Row>
    </CardBody>
  </Card>

const mapStateToProps = state => ({
  datosContenido: state.datosContenido.contenidos,
});
const mapDispatchToProps = dispatch => {
  return {
  };
};
export default
  connect(
    mapStateToProps,
    null
  )(PreguntasVehiculos)
